// @ts-strict-ignore
import type { AggregationSourceData } from './types';
import type { Option } from '@usealloy/component-library';
import { AggregationType, TimeframeUnit } from 'flow/store/engine/constants';

// TODO(OAK-1060): Remove INITIAL_AGGREGATION_CONFIG once all sourceData
// fields (scope, timeframe) are persisted in AggregationComponent and
// transformations are complete.
export const INITIAL_AGGREGATION_CONFIG: AggregationSourceData = {
  name: 'Entities',
  description: '',
  aggregation: {
    columnSlug: 'entity_token',
    aggregationType: AggregationType.COUNT_DISTINCT,
  },
  scope: 'all',
  filters: [],
  timeframeIntervalStart: 0,
  timeframeIntervalEnd: 30,
  timeframeUnit: TimeframeUnit.DAYS,
};

export const SCOPE_MAX_DAYS = {
  all: 90,
  entity: 365,
  group: 365,
} as const;

export const AGGREGATION_TYPE_LABELS: Record<AggregationType, string> = {
  [AggregationType.COUNT_DISTINCT]: 'Distinct Count',
  [AggregationType.COUNT]: 'Count',
  [AggregationType.SUM]: 'Sum',
  [AggregationType.AVG]: 'Average',
  [AggregationType.MIN]: 'Min',
  [AggregationType.MAX]: 'Max',
};

export const BOOLEAN_FILTER_OPTIONS: Option[] = [
  { value: 'true', label: 'true' },
  { value: 'false', label: 'false' },
];

export const SCOPE_OPTIONS: (Option & { tooltipText?: string })[] = [
  { value: 'all', label: 'Across all Entities', tooltipText: 'Calculates velocity across all entities' },
  { value: 'entity', label: 'For the Entity being evaluated' },
  { value: 'group', label: 'For all Entities in this Group' },
];

export const TIMEFRAME_UNIT_OPTIONS: Option[] = Object.values(TimeframeUnit).map(
  value => ({ value, label: value }),
);
